const objToQs = (obj) =>  {
    if(!obj) return '';
    return Object.keys(obj).map(param => {
        const value = obj[param];
        if(!value) {
            return null;
        }

        return `${param}=${encodeURIComponent(value)}`;
    })
        .filter(item => item)
        .join('&');
};


export {objToQs};


// WEBPACK FOOTER //
// ./src/services/API/Utils.js